<div [formGroup]="form"  class="tw-w-full">


  <!-- without formGroupName -->
  <div *ngIf="!formGroupName" class="tw-w-full">

    <mat-slide-toggle [formControlName]="formControlName" [(ngModel)]="value">
      {{label|translate}}
    </mat-slide-toggle>

  </div>

  <!-- with formGroupName -->
  <div [formGroupName]="formGroupName" *ngIf="formGroupName" class="tw-w-full">

    <mat-slide-toggle [formControlName]="formControlName" [(ngModel)]="value">
      {{label|translate}}
    </mat-slide-toggle>

  </div>

</div>
